import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { useState } from 'react';

import OutOfOfficeCalendar from '@components/OutOfOfficeCalendar';
import OutOfOfficeStats from '@components/OutOfOfficeStats';
import ExpertPage from '@components/pageTypes/ExpertPage';
import useMyExpert from '@hooks/useMyExpert';
import { ExpertGlobalRoleEnum, GetOutOfOfficePeriodsQuery } from '@typing/Generated';

type OutOfOfficePeriod = NonNullable<
  NonNullable<NonNullable<GetOutOfOfficePeriodsQuery['outOfOfficePeriods']['edges']>[number]>['node']
>;

const ExpertOutOfOfficeSchedulePage = () => {
  const myExpert = useMyExpert();

  const [editingOoop, setEditingOoop] = useState<OutOfOfficePeriod>();

  return (
    <ExpertPage
      helmetKey="pageTitles.expert.outOfOfficePeriod.list"
      imageName="map"
      titleKey="pages.expert.outOfOffice.title"
    >
      <IonGrid>
        <IonRow>
          <IonCol size={myExpert?.expertGlobalRole === ExpertGlobalRoleEnum.manager ? '8' : '12'}>
            <OutOfOfficeCalendar onEdit={setEditingOoop} />
          </IonCol>

          {myExpert?.expertGlobalRole === ExpertGlobalRoleEnum.manager && (
            <IonCol size="4">
              <OutOfOfficeStats editingOoop={editingOoop} onEditCanceled={() => setEditingOoop(undefined)} />
            </IonCol>
          )}
        </IonRow>
      </IonGrid>
    </ExpertPage>
  );
};

export default ExpertOutOfOfficeSchedulePage;
